import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Build14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_41)'>
      <path
        d='M1.5 0.25C0.809644 0.25 0.25 0.809644 0.25 1.5V10.5C0.25 11.1904 0.809644 11.75 1.5 11.75H3V10.25H1.75V4.25H3V2.75H1.75V1.75H12.25V2.75H4.5V4.25H12.25V10.25H11V11.75H12.5C13.1904 11.75 13.75 11.1904 13.75 10.5V1.5C13.75 0.809644 13.1904 0.25 12.5 0.25H1.5Z'
        fill='currentColor'
      />
      <path
        d='M6.03725 4.82275L5.12446 5.35078C4.00554 5.99804 3.25 7.20966 3.25 8.59863C3.25 9.82633 3.84026 10.9155 4.75 11.5988V13.0986H6.25V10.7647L5.87554 10.5481C5.20106 10.1579 4.75 9.43051 4.75 8.59863C4.75 8.20587 4.85055 7.8364 5.02769 7.51471L5.38055 9.34863H8.61945L8.97231 7.51471C9.14945 7.8364 9.25 8.20587 9.25 8.59863C9.25 9.43051 8.79894 10.1579 8.12446 10.5481L7.75 10.7647V13.0986H9.25V11.5988C10.1597 10.9155 10.75 9.82633 10.75 8.59863C10.75 7.20966 9.99446 5.99804 8.87554 5.35078L7.96275 4.82275L7.38055 7.84863H6.61945L6.03725 4.82275Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_41'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Build14.displayName = 'Build14';
export default Build14;
